// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__BCXs7","modalFooterButton":"ModalNotes_modalFooterButton__30xvZ"};